import store from '@/state/store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        // Cible du lien reçu par email : ?token=…&email=…
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('../views/pages/account/reset-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['auth/loggedIn']) {
                    next({ name: 'home' })
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },
    {
        path: '/client',
        name: 'client',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/Client')
    },
    {
        path: '/file',
        name: 'Documents',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/file')
    },
    {
        path: '/profile',
        name: 'profile',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/profile')
    },
    {
        path: '/parametre',
        name: 'parametre',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/configuration/config')
      },
    {
        path: '/dossier/:id',
        name: 'dossier',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/Dossier')
    },
    {
        path: '/generation_document',
        name: 'generation-rapide',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/generate_document')
    },
    {
        path: '/service',
        name: 'service',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/Service')
    },
    {
        path: '/sous-service',
        name: 'sous-service',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/sous_service')
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/acceuil')
    },
    {
        path: '/dossier',
        name: 'dossiers',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/acceuil')
    },
    {
        path: '/pochettes',
        name: 'pochettes',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/pochettes')
    },
    {
        path: '/chat',
        name: 'Chat',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/chat/index')
    },
    
    {
        // Boîte Gmail de l'utilisateur (OAuth). L'état de navigation vit dans
        // la query : ?libelle=, ?categorie=, ?q=, ?dossier=, ?c= (conversation).
        // Google revient aussi ici après le consentement (?gmail=…).
        path: '/messagerie',
        name: 'messagerie',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/messagerie/index')
    },
    {
        // Ancienne démo « Inbox » du template, remplacée par la messagerie réelle.
        path: '/inbox',
        redirect: '/messagerie',
    },
 
    
  
    {
        path: '/auth/login-1',
        name: 'login-1',
        meta: { authRequired: true },
        component: () => import('../views/pages/sample-auth/login-1')
    },
    {
        path: '/auth/register-1',
        name: 'register-1',
        meta: { authRequired: true },
        component: () => import('../views/pages/sample-auth/register-1')
    },
    {
        path: '/auth/lock-screen-1',
        name: 'Lock-screen-1',
        meta: { authRequired: true },
        component: () => import('../views/pages/sample-auth/lock-screen-1')
    },
     
  
  
  
    {
        path: '/pages/error-404',
        name: 'Error-404',
        meta: { authRequired: true },
        component: () => import('../views/pages/utility/error-404')
    },
    {
        path: '/pages/error-500',
        name: 'Error-500',
        meta: { authRequired: true },
        component: () => import('../views/pages/utility/error-500')
    },
     
]
